import { render, staticRenderFns } from "./GroupRecording.vue?vue&type=template&id=315e60e0&scoped=true&"
import script from "./GroupRecording.vue?vue&type=script&lang=js&"
export * from "./GroupRecording.vue?vue&type=script&lang=js&"
import style0 from "./GroupRecording.vue?vue&type=style&index=0&id=315e60e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e60e0",
  null
  
)

export default component.exports